interface fourRowTable {
    no?: number,
    typeName?: string,
    initBalance?: string,
    balance?: string,
    countBalance?: string,
    actualBalance?: string,
    endBalance?: string,
    canEdit?: boolean,
    colspan?: string,
    align?: string,
    colsisHeadpan?: boolean,
    indent?: number,
    item?: string,
    isHead?: boolean,
    title?: string,
    typeNo?: string,
    initBalanceTop?: string,
    balanceTop?: string,
    countBalanceTop?: string,
    actualBalanceTop?: string,
    endBalanceTop?: string,
    deductBalanceTop?: string,
    deductBalance?: string,
    tdTwo?: boolean,
    idx?: number,
    index?: number,
    accountBookId?:number | null
    endPeriod?:string | null,
    startPeriod?:string | null,
    id?:number | null,
    type?:number | null
}

let list = [
    {
        idx: 0,
        title: "一、税额抵减情况",
        colspan: "8",
        align: "center",
        indent: 0,
        isHead: true
    },
    {
        idx: 1,
        typeNo: "序号",
        align: "center",
        item: "抵减项目	",
        initBalanceTop: "期初余额",
        balanceTop: "本期发生额",
        countBalanceTop: "本期应抵减税额",
        actualBalanceTop: "本期实际抵减税额",
        endBalanceTop: "期末余额",
        indent: 0,
        isHead: true
    },
    {
        idx: 2,
        align: "center",
        initBalanceTop: "1",
        balanceTop: "2",
        countBalanceTop: "3=1+2",
        actualBalanceTop: "4≤3",
        endBalanceTop: "5=3-4",
        indent: 0,
        isHead: true
    },
    {
        idx: 3,
        no: 1,
        typeName: "增值税税控系统专用设备费及技术维护费",
        initBalance: "",
        index: 0,
        balance: "",
        countBalance: "",
        actualBalance: "",
        endBalance: "",
        canEdit: true
    },
    {
        idx: 4,
        no: 2,
        typeName: "分支机构预征缴纳税款",
        initBalance: "",
        index: 1,
        balance: "",
        countBalance: "",
        actualBalance: "",
        endBalance: ""
    },
    {
        idx: 5,
        no: 3,
        typeName: "建筑服务预征缴纳税款",
        initBalance: "",
        index: 2,
        balance: "",
        countBalance: "",
        actualBalance: "",
        endBalance: "",
        canEdit: true
    },
    {
        idx: 6,
        no: 4,
        typeName: "销售不动产预征缴纳税款",
        initBalance: "",
        index: 3,
        balance: "",
        countBalance: "",
        actualBalance: "",
        endBalance: "",
        canEdit: true
    },
    {
        idx: 7,
        no: 5,
        typeName: "出租不动产预征缴纳税款",
        initBalance: "",
        index: 4,
        balance: "",
        countBalance: "",
        actualBalance: "",
        endBalance: "",
        canEdit: true
    },
    {
        idx: 8,
        title: "二、加计抵减情况",
        colspan: "8",
        align: "center",
        indent: 0,
        isHead: true
    },
    {
        idx: 9,
        typeNo: "序号",
        align: "center",
        item: "加计抵减项目	",
        initBalanceTop: "期初余额",
        balanceTop: "本期发生额",
        countBalanceTop: "本期调减额",
        deductBalanceTop: "本期可抵减额",
        actualBalanceTop: "本期实际抵减额",
        endBalanceTop: "期末余额",
        indent: 0,
        isHead: true,
        tdTwo: true
    },
    {
        idx: 10,
        align: "center",
        initBalanceTop: "1",
        balanceTop: "2",
        countBalanceTop: "3",
        deductBalanceTop: "4=1+2-3",
        actualBalanceTop: "5",
        endBalanceTop: "6=4-5",
        indent: 0,
        isHead: true,
        tdTwo: true
    },
    {
        idx: 11,
        no:6,
        typeName: "一般项目加计抵减额计算",
        initBalance: "",
        index: 5,
        balance: "",
        deductBalance: "",
        countBalance: "",
        actualBalance: "",
        endBalance: "",
        canEdit: true,
        tdTwo: true
    },
    {
        idx: 12,
        no:7,
        typeName: "即征即退项目加计抵减额计算",
        initBalance: "",
        index: 6,
        balance: "",
        deductBalance: "",
        countBalance: "",
        actualBalance: "",
        endBalance: "",
        canEdit: true,
        tdTwo: true
    },
    {
        idx: 13,
        no:8,
        typeName: "合计",
        initBalance: "",
        index: 7,
        balance: "",
        deductBalance: "",
        countBalance: "",
        actualBalance: "",
        endBalance: "",
        canEdit: false,
        tdTwo: true
    },
];

let fourRowTable = {
    list: list,
}
export default fourRowTable